import { OrderFormatOption as r } from "@ancon/wildcat-types";
import l from "./getSettingsForOrderFormat.mjs";
var a = /* @__PURE__ */ ((t) => (t[t.Preset1 = 1] = "Preset1", t[t.Preset2 = 2] = "Preset2", t[t.Preset3 = 3] = "Preset3", t))(a || {});
function i(t) {
  if (t) {
    const e = [];
    return t.percentage1Enabled && e.push({
      value: t.percentage1Value,
      preset: 1
      /* Preset1 */
    }), t.percentage2Enabled && e.push({
      value: t.percentage2Value,
      preset: 2
      /* Preset2 */
    }), t.percentage3Enabled && e.push({
      value: t.percentage3Value,
      preset: 3
      /* Preset3 */
    }), e;
  }
  return [];
}
function f(t, e) {
  const { orderFormatSettings: o } = t, n = l(e, o);
  if ((r.AOTipEnabled & n.options) === r.AOTipEnabled) {
    const s = (r.AOCustomTipsEnabled & n.options) === r.AOCustomTipsEnabled, u = i(n.aoTippingPercentages);
    return {
      aoAllowCustomTipping: s,
      tipPercentages: u
    };
  }
  return null;
}
export {
  a as TipPercentagePreset,
  f as default
};
